import { getContactNumber } from '@insight/toolkit-utils/lib/helpers/localeHelpers'

export default function getPhoneNumber(locale) {
  return getContactNumber(locale)
}
